import {getColor} from "@/styles/ThemeConfig";
import styled, {css} from "styled-components";
import LocationIcons from '/public/images/location.svg';
import CalendarIcons from '/public/images/calendar.svg';
import ForceSSRLink from "@/components/other/ForceSSRLink";


import Image from 'next/image';
import {breakpoints} from "@/styles/sizes";
import {Button} from "@/components/base/Buttons";
import {DangerousDescriptionWrapper} from "@/styles/GlobalStyles";

// Styled Components for styling the divs
const GreyBlock = styled.div`
  display: flex;
  justify-content: space-between;
    align-items: center;
  background-color: ${getColor('grayBackground')};
  padding: 10px 20px;
`;

const Left = styled.div`
  flex: 1;
  text-align: left;
`;

const Right = styled.div`
  flex: 1;
  text-align: left;
`;

const Item = styled.div`
    display: flex;
    gap: 5px;
    align-items: flex-start;
    
    img{
        margin-top: 4px;
    }
    
  margin-bottom: 10px;
  
  p {
    font-size: 16px;
    margin: 0;
      font-family: Verdana, sans-serif!important;
  }

  span {
    font-family: Verdana, sans-serif!important;
  }

  a {
      font-family: Verdana, sans-serif!important;
    color: blue;
    text-decoration: none;
  }
`;

const TourMeetingSectionWrapper = styled.div`
    background: white;
    padding: 50px;
    @media only screen and (${breakpoints.mobile}) {
        padding: 40px 20px;
    }
`;

const FullyBookedText = styled.p`
    font-size: 16px;
    font-family: 'Josefin Sans';
    margin: 20px 0;

    h1{
        text-align: center;
        text-transform: uppercase;
        margin-bottom: 30px;
    }
    a{
        color:${getColor('gold')};
    }

`;



const IframeEmbed = styled.div`
    iframe{
        width: 100%;
        height: 300px;
    }
`;

export default function TourMeetingSection({title,description,email,spots,isUpgrade,guideInfo, fullyBooked, fullyBookedText, cityName, ...rest})
{
    return (
        (title ||
        description ||
        email ||
        spots ||
        isUpgrade ||
        guideInfo ||
        fullyBooked ||
        fullyBookedText) &&<TourMeetingSectionWrapper id={'CONTACT'} {...rest}>
            {email && <div   style={{
                padding: '20px',
                backgroundColor: getColor('grayBackground'),
            }}>
                <p style={{
                    textTransform: 'uppercase',
                    color: getColor('green'),
                    marginBottom: '10px',
                }}>Secret Food Tours {cityName}</p>
                <p style={{
                    fontWeight: 'bold',
                    fontSize: '24px',
                    color: getColor('gold'),
                    marginBottom: '10px',
                }}>Contact Us</p>
                <ForceSSRLink
                    href={`mailto:${email}`}
                    style={{
                        color: getColor('green'),
                    }}
                >{email}</ForceSSRLink>
                <div style={{
                    marginTop: '10px',
                }}>
                    <Button variant={'black'} href={"/private-bookings"}>Private Tours</Button>
                </div>
            </div>}


            {title && <h2 className={'h4'} style={{
                textTransform: 'uppercase',
                marginTop: '20px',
                color: getColor('gold'),
                fontWeight: 'bold',
            }}>{title}</h2>}
            {description && <DangerousDescriptionWrapper
                customStyle={css`
                font-size: 16px !important;
                margin-bottom: 20px;
            `}
                dangerouslySetInnerHTML={{__html: description}}
            />}


            {spots && <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap:'10px'
            }}>{spots?.map((item, index) => {
                return <div
                    key={index}
                >
                    {
                        (item?.dayFrom ||
                        item?.dayTo ||
                        item?.locationLink ||
                        item?.location)
                        && <GreyBlock>
                            <Left>
                                <Item>
                                    <Image src={CalendarIcons} alt={'CalendarIcons'} width={15} height={15}/>
                                    <p>{item?.dayFrom} {item?.dayTo && '-'} {item?.dayTo} <br/><span style={{color:getColor('lightGreen')}}>{item?.dayHelpText}</span></p>
                                </Item>
                            </Left>
                            <Right>
                                <Item>
                                    {item?.location && <Image src={LocationIcons} alt={'LocationIcons'} width={15} height={15}/>}
                                    <p>
                                        <ForceSSRLink
                                            href={item?.locationLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: getColor('gold'),
                                            }}
                                        >
                                            {item?.location} <br/>{item?.location ? 'Google Maps' : ''}
                                        </ForceSSRLink>
                                    </p>
                                </Item>
                            </Right>
                        </GreyBlock>
                    }


                    {item?.embed && <IframeEmbed dangerouslySetInnerHTML={{__html:item?.embed}} />}
                </div>
            })}</div>}

            {
                !isUpgrade && <>
                    <div style={{
                        fontSize: '16px',
                        fontFamily: 'Josefin Sans',
                        color: getColor('lightGreen'),
                        margin: '20px 0',
                    }}>
                        {guideInfo}
                    </div>

                    <FullyBookedText dangerouslySetInnerHTML={{__html:fullyBookedText}}/>
                </>
            }

        </TourMeetingSectionWrapper>
        )

}
